import React from "react";
import Typography from "@mui/material/Typography";
import { Button, Grid } from "@mui/material";

const CommonHeader = ({
  mainTitle,
  buttonText,
  handleSubmit,
  SecondButtonText,
  handleSecondButtonSubmit,
}) => {
  return (
    <Grid container alignItems={"center"} style={{ marginBottom: 15 }}>
      <Grid item xs container alignItems={"center"}>
        <Typography style={mainTitleStyles}>
          {mainTitle && mainTitle}
        </Typography>
      </Grid>
      <Grid item xs container>
        {buttonText && (
          <Button
            variant="contained"
            style={buttonStyles}
            onClick={() => handleSubmit()}
          >
            {buttonText}
          </Button>
        )}
        {SecondButtonText && (
          <Button
            variant="contained"
            style={{ ...buttonStyles, marginLeft: 20 }}
            onClick={() => handleSecondButtonSubmit()}
          >
            {SecondButtonText}
          </Button>
        )}
      </Grid>
    </Grid>
  );
};

export default CommonHeader;

const mainTitleStyles = {
  color: "#020303",
  fontSize: 24,
  fontWeight: 700,
  fontFamily: "Avenir Book, sans-serif",
};

const buttonStyles = {
  marginLeft: "auto",
  textTransform: "none",
  background: "#00A7CD",
  fontSize: 15,
  fontWeight: 500,
  fontFamily: "Avenir Book, sans-serif",
};
